import { useState } from "react";
import { Copy, Check, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";

export const TempPasswordPanel = ({ email, password }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => { await navigator.clipboard.writeText(password); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  return (
    <div className="rounded-lg border-2 border-amber-400 bg-amber-50 p-4" data-testid="temp-password-panel">
      <div className="flex items-center gap-2 text-sm font-semibold text-amber-900"><KeyRound className="w-4 h-4" />Temporary password for {email}</div>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <code className="font-mono text-lg font-bold tracking-wider text-slate-900 bg-white border border-amber-300 rounded px-3 py-1.5 select-all" data-testid="temp-password-value">{password}</code>
        <Button size="sm" variant="outline" onClick={copy} data-testid="temp-password-copy">{copied ? <Check className="w-4 h-4 mr-1 text-emerald-600" /> : <Copy className="w-4 h-4 mr-1" />}{copied ? "Copied" : "Copy"}</Button>
      </div>
      <p className="mt-2 text-xs text-amber-900">This will not be shown again. Pass it on privately — they must choose their own password at first sign-in.</p>
    </div>
  );
};
